"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EntityDetailsBanner = exports.EntityDetailsBannerDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var entity_banner_1 = require("./entity-banner");
var entity_follow_controls_1 = require("./entity-follow-controls");
var use_entity_definition_1 = require("../../hooks/use-entity-definition");
var use_entity_definition_named_1 = require("../../hooks/use-entity-definition-named");
var use_lang_1 = require("../../hooks/use-lang");
var person_cell_1 = require("./person-cell");
var content_node_1 = require("./content-node");
var cell_label_1 = require("../elements/cell-label");
var menu_context_1 = require("../context/menu-context");
var entity_slug_label_1 = require("./entity-slug-label");
var current_user_can_1 = require("../../utils/current-user-can");
exports.EntityDetailsBannerDefaultProps = {
  size: 'large',
  imageSize: 'large',
  showModerator: false,
  showBadge: true,
  showDescription: false,
  alignItems: 'center',
  showFollowControls: true
};
// -------- Child Component Props -------->
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var FollowControlsStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    margin-top: ", ";\n    padding: 0 2px;\n  "], ["\n    margin-top: ", ";\n    padding: 0 2px;\n  "])), theme_1.theme.UNIT(1))
});
var ModeratorStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var DescriptionStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var SubTitleStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    margin-top: ", ";\n    margin-bottom: ", ";\n  "], ["\n    margin-top: ", ";\n    margin-bottom: ", ";\n  "])), theme_1.theme.UNIT(1), theme_1.theme.UNIT(1))
});
var SlugStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components --------->
var My = {
  Container: (0, styled_components_1.default)(entity_banner_1.EntityBanner)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Slug: (0, styled_components_1.default)(entity_slug_label_1.EntitySlugLabel)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), SlugStyles),
  FollowControls: (0, styled_components_1.default)(entity_follow_controls_1.EntityFollowControls)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), FollowControlsStyles),
  Moderator: (0, styled_components_1.default)(person_cell_1.PersonCell)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), ModeratorStyles),
  SubTitle: (0, styled_components_1.default)(cell_label_1.CellLabel)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), SubTitleStyles),
  Description: (0, styled_components_1.default)(content_node_1.ContentNode)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), DescriptionStyles)
};
var EntityDetailsBanner = function (props) {
  var className = props.className,
    entity = props.entity,
    size = props.size,
    imageSize = props.imageSize,
    showBadge = props.showBadge,
    children = props.children,
    showMenu = props.showMenu,
    subTitle = props.subTitle,
    badge = props.badge,
    usePadding = props.usePadding,
    entityTypeName = props.entityTypeName,
    showModerator = props.showModerator,
    alwaysShowIcon = props.alwaysShowIcon,
    alignItems = props.alignItems,
    title = props.title,
    showFollowControls = props.showFollowControls,
    subtitle = props.subtitle;
  var definition = entityTypeName ? (0, use_entity_definition_named_1.useEntityDefinitionNamed)(entityTypeName) : (0, use_entity_definition_1.useEntityDefinition)(entity);
  var t = (0, use_lang_1.useLang)();
  var slug = entity.slug,
    siteSlug = entity.siteSlug;
  var banner = definition.banner;
  var controls = props.controls || [];
  var useFollowers = definition === null || definition === void 0 ? void 0 : definition.useFollowers;
  var useModerators = definition === null || definition === void 0 ? void 0 : definition.useModerators;
  if (useModerators && showModerator && entity.moderator) {
    controls.unshift(react_1.default.createElement(My.Moderator, {
      label: t('Moderator'),
      entity: entity.moderator
    }));
  }
  var menuContext = (0, menu_context_1.useMenuContext)();
  var showSlug = props.showSlug === undefined ? (0, current_user_can_1.currentUserCan)('write:any') : props.showSlug;
  return react_1.default.createElement(menu_context_1.MenuProvider, {
    value: __assign(__assign({}, menuContext), {
      useEditRoute: true
    })
  }, react_1.default.createElement(My.Container, {
    showMenu: showMenu,
    usePadding: usePadding,
    alwaysShowIcon: alwaysShowIcon,
    subTitle: subTitle,
    title: title,
    showBadge: showBadge,
    badge: badge,
    useImageViewer: true,
    entityTypeName: entityTypeName,
    alignItems: alignItems,
    size: banner.size || size,
    imageSize: banner.imageSize || banner.size || imageSize || size,
    controls: controls,
    entity: entity,
    className: className
  }, children, subtitle && react_1.default.createElement(My.SubTitle, null, subtitle), showSlug && slug && react_1.default.createElement(My.Slug, {
    entity: entity
  }), showSlug && siteSlug && react_1.default.createElement(My.Slug, {
    entity: entity,
    field: "siteSlug"
  }), useFollowers && showFollowControls && react_1.default.createElement(My.FollowControls, {
    entity: entity
  })));
};
exports.EntityDetailsBanner = EntityDetailsBanner;
exports.EntityDetailsBanner.defaultProps = exports.EntityDetailsBannerDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12;